import { HBO_COMMUNICATION_ASSET_KEYS } from '../constants';

// El lector de llaves (getTranslationEmptyOrNullKey) devuelve el NOMBRE de la llave cuando
// no existe: nunca debe llegar al usuario (CF-16). Sin texto valido devuelve null: no hay
// fallback y la pantalla no pinta ese elemento.
export const resolveHboCommunicationText = (value, key) => {
  if (typeof value !== 'string' || value.trim() === '' || value === key) {
    return null;
  }

  return value;
};

export const resolveHboCommunicationAsset = (assets, key) => {
  const value = assets?.[key];

  return typeof value === 'string' && value !== '' ? value : null;
};

// Claro video y Claro tv+ ocupan la misma posicion en el Figma: son excluyentes
export const resolveHboCommunicationClaroLogo = assets => {
  const videoLogo = resolveHboCommunicationAsset(
    assets,
    HBO_COMMUNICATION_ASSET_KEYS.CLARO_VIDEO_LOGO,
  );

  if (videoLogo) {
    return { type: 'video', url: videoLogo };
  }

  const tvLogo = resolveHboCommunicationAsset(
    assets,
    HBO_COMMUNICATION_ASSET_KEYS.CLARO_TV_LOGO,
  );

  return tvLogo ? { type: 'tv', url: tvLogo } : null;
};
